import { StyledFlex } from '@dreryk/react-components';

import { AdjustmentDataText } from '../../shared/adjustment/AdjustmentDataText';
import { AdjustmentByFormBean } from '../../shared/form/adjustment/adjustment.types';
import { VisitMedicalServiceTableBean } from '../../shared/medicalServices/medicalServices.types';
import { MedicalServicesTotalPriceText } from '../../shared/medicalServices/MedicalServicesTotalPriceText';
import { VisitSettlementControl } from '../../visitSettlement.types';

import { VisitSettlementPriceChangeReasonAction } from './priceChangeReason/VisitSettlementPriceChangeReasonAction';

type VisitSettlementFormTabInteractiveTableBottomElementProps = {
   readonly adjustmentBy: AdjustmentByFormBean | undefined;
   readonly control: VisitSettlementControl;
   readonly medicalServices: VisitMedicalServiceTableBean[];
   readonly editable: boolean;
   readonly appointmentId: number;
};

export const VisitSettlementFormTabInteractiveTableBottomElement = (
   props: VisitSettlementFormTabInteractiveTableBottomElementProps
): JSX.Element => {
   return (
      <StyledFlex gap={'4px'} alignItems={'center'} justifyContent={props.adjustmentBy ? 'space-between' : 'flex-end'}>
         {props.adjustmentBy ? (
            <AdjustmentDataText author={props.adjustmentBy.author} date={props.adjustmentBy.date} />
         ) : null}
         <StyledFlex alignItems={'center'} gap={16}>
            <MedicalServicesTotalPriceText medicalServices={props.medicalServices} />
            {props.editable ? (
               <VisitSettlementPriceChangeReasonAction control={props.control} appointmentId={props.appointmentId} />
            ) : null}
         </StyledFlex>
      </StyledFlex>
   );
};
